import React from 'react';

const DotIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M7.8 10a2.2 2.2 0 0 0 4.4 0 2.2 2.2 0 0 0-4.4 0z" />
    </svg>
  );
};

export default DotIcon;
